export const HIDDEN_ACTION_CLASS_TYPES = ['event', 'experience'];
